import { render, staticRenderFns } from "./CategoriesNew.vue?vue&type=template&id=3bbacec0&scoped=true&"
import script from "./CategoriesNew.vue?vue&type=script&lang=js&"
export * from "./CategoriesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbacec0",
  null
  
)

export default component.exports